import {
	modalAdd
} from "./modalAdd";

export function fryingPan(productId) {
	// 変数名は型番
	// ラウンドスキレット 12cm
	const LV12F1 = {
		rotateClass: "is-rotate",
		class: "",
		cm: "12cm",
		en: "LAVA ROUND SKILLET",
		jp: "ラヴァ ラウンドスキレット",
		price: "3,500",
		img: "/wp/wp-content/themes/lava/assets/img/product/frying-pan/img_round_skillet12_modal.png",
		size: "12cm",
		capacity: "0.20L",
		amount: "1人前",
		diameterText: "直径",
		diameter: "12.6cm",
		width: "25.3cm",
		height: "4.3cm",
		weight: "0.6kg",
		bottom: "4.0mm",
		edge: "4.0mm",
		number: "LV12F1",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv12f1/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv12f1.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_round_skillet.jpg",
		note: "※横と高さは、本体の取っ手を含む"
	};

	// ラウンドスキレット 16cm
	const LV16F1 = {
		rotateClass: "is-rotate",
		class: "",
		cm: "16cm",
		en: "LAVA ROUND SKILLET",
		jp: "ラヴァ ラウンドスキレット",
		price: "4,500",
		img: "/wp/wp-content/themes/lava/assets/img/product/frying-pan/img_round_skillet16_modal.png",
		size: "16cm",
		capacity: "0.4L",
		amount: "1-2人前",
		diameterText: "直径",
		diameter: "16.9cm",
		width: "29.5cm",
		height: "4.4cm",
		weight: "0.9kg",
		bottom: "4.0mm",
		edge: "4.0mm",
		number: "LV16F1",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv16f1/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv16f1.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_round_skillet.jpg",
		note: "※横と高さは、本体の取っ手を含む"
	};

	// ラウンドスキレット 20cm
	const LV20F1 = {
		rotateClass: "is-rotate",
		class: "",
		cm: "20cm",
		en: "LAVA ROUND SKILLET",
		jp: "ラヴァ ラウンドスキレット",
		price: "5,500",
		img: "/wp/wp-content/themes/lava/assets/img/product/frying-pan/img_round_skillet20_modal.png",
		size: "20cm",
		capacity: "0.8L",
		amount: "1-2人前",
		diameterText: "直径",
		diameter: "20.0cm",
		width: "33.0cm",
		height: "4.5cm",
		weight: "1.8kg",
		bottom: "4.0mm",
		edge: "4.0mm",
		number: "LV20F1",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv20f1/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv20f1.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_round_skillet.jpg",
		note: "※横と高さは、本体の取っ手を含む"
	};

	// ラウンド ラヴァ フライパン 28cm
	const LV28F2 = {
		rotateClass: "",
		class: "",
		cm: "28cm",
		en: "LAVA ROUND FRYIN PANG",
		jp: "ラヴァ フライパン",
		price: "7,000",
		img: "/wp/wp-content/themes/lava/assets/img/product/frying-pan/img_round_pan28_modal.png",
		size: "28cm",
		capacity: "2.30L",
		amount: "4-6人前",
		diameterText: "直径",
		diameter: "32.5cm",
		width: "46.4cm",
		height: "6.1cm",
		weight: "2.7kg",
		bottom: "3.0mm",
		edge: "3.0mm",
		number: "LV28F2",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv28f2/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv28f2.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_round_pan.jpg",
		note: "※横と高さは、本体の取っ手を含む"
	};

	// ラウンド ラヴァ フライパン 30cm
	const LV30F2 = {
		rotateClass: "",
		class: "",
		cm: "30cm",
		en: "LAVA ROUND FRYIN PANG",
		jp: "ラヴァ フライパン",
		price: "7,500",
		img: "/wp/wp-content/themes/lava/assets/img/product/frying-pan/img_round_pan30_modal.png",
		size: "30cm",
		capacity: "2.8L",
		amount: "4-6人前",
		diameterText: "直径",
		diameter: "34.6cm",
		width: "48.4cm",
		height: "6.0cm",
		weight: "2.8kg",
		bottom: "3.5mm",
		edge: "3.0mm",
		number: "LV30F2",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv30f2/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv30f2.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_round_pan.jpg",
		note: "※横と高さは、本体の取っ手を含む"
	};

	// ラヴァ オーバルスキレット 23cm
	const LV23FO = {
		rotateClass: "",
		class: "",
		cm: "17×23cm",
		en: "LAVA OVAL SKILLET",
		jp: "ラヴァ オーバルスキレット",
		price: "3,500",
		img: "/wp/wp-content/themes/lava/assets/img/product/frying-pan/img_oval_skillet26_modal.png",
		size: "17×23cm",
		capacity: "0.35L",
		amount: "1人前",
		diameterText: "縦",
		diameter: "17.8cm",
		width: "38.0cm",
		height: "4.1cm",
		weight: "1.3kg",
		bottom: "3.5mm",
		edge: "3.5mm",
		number: "LV23FO",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv23fo/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv23fo.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_oval_skillet.jpg",
		note: "※横と高さは、本体の取っ手を含む"
	};

	// ラヴァ グリルパン 12cm
	const LV26FG = {
		rotateClass: "",
		class: "",
		cm: "26cm",
		en: "LAVA GRILL PAN",
		jp: "ラヴァ グリルパン",
		price: "7,000",
		img: "/wp/wp-content/themes/lava/assets/img/product/frying-pan/img_grill_pan26_modal.png",
		size: "26x26cm",
		capacity: "1.5L",
		amount: "4人前",
		diameterText: "縦",
		diameter: "28.5cm",
		width: "49.5cm",
		height: "5.7cm",
		weight: "2.8kg",
		bottom: "4.0mm",
		edge: "3.0mm",
		number: "LV26FG",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv26fg/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv26fg.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_grill_pan.jpg",
		note: "※横と高さは、本体の取っ手を含む"
	};

	// ラヴァ グリルプレス 21cm
	const LV21GP = {
		rotateClass: "",
		class: "is-none",
		cm: "21cm",
		en: "LAVA GRILL PRESS",
		jp: "ラヴァ グリルプレス",
		price: "4,000",
		img: "/wp/wp-content/themes/lava/assets/img/product/frying-pan/img_grill_press21_modal.png",
		size: "21x21cm",
		capacity: "0.L",
		amount: "",
		diameterText: "縦",
		diameter: "21.1cm",
		width: "21.1cm",
		height: "4.5cm",
		weight: "1.5kg",
		bottom: "3.7mm",
		edge: "5.7mm",
		number: "LV21GP",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv21gp/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv21gp.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_grill_press.jpg",
		note: ""
	};

	switch (productId) {
		case "LV12F1": {
			modalAdd(LV12F1);
			break;
		}
		case "LV16F1": {
			modalAdd(LV16F1);
			break;
		}
		case "LV20F1": {
			modalAdd(LV20F1);
			break;
		}
		case "LV28F2": {
			modalAdd(LV28F2);
			break;
		}
		case "LV30F2": {
			modalAdd(LV30F2);
			break;
		}
		case "LV23FO": {
			modalAdd(LV23FO);
			break;
		}
		case "LV26FG": {
			modalAdd(LV26FG);
			break;
		}
		case "LV21GP": {
			modalAdd(LV21GP);
			break;
		}
	}
}